import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Layout from '../components/layout/Layout'
import { useAuth } from '../hooks/useAuth'

function AuthCallbackPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const { loading } = useAuth()
  const error = searchParams.get('error')

  useEffect(() => {
    // Actual code exchange is handled inside AuthProvider via AuthCallbackHandler.
    // This page just shows spinner / error while that happens.
  }, [])

  if (error) {
    return (
      <Layout>
        <div className='registration'>
          <div className='registration-error'>
            <h1>{t('auth.error')}</h1>
            <p>{error}</p>
            <p>
              {t('auth.contactSupport')}{' '}
              <a href='mailto:contact@cloudsoft.com.pl'>{t('auth.contactSupportLink')}</a>.
            </p>
          </div>
        </div>
      </Layout>
    )
  }

  return (
    <Layout>
      <div className='registration'>
        <div className='registration-success'>
          <h1>{loading ? t('auth.signingIn') : t('auth.redirecting')}</h1>
          <p>{t('auth.pleaseWait')}</p>
        </div>
      </div>
    </Layout>
  )
}

export default AuthCallbackPage
